import { render, staticRenderFns } from "./monetaryActionRealTypeSelectBox.vue?vue&type=template&id=c238b648&scoped=true&"
import script from "./monetaryActionRealTypeSelectBox.vue?vue&type=script&lang=js&"
export * from "./monetaryActionRealTypeSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c238b648",
  null
  
)

export default component.exports